
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import rpm from "../images/carepro.jpg";

// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";

function Privacypolicy() {

  const currentDate = new Date().toLocaleDateString("en-IN", {
  day: "2-digit",
  month: "long",
  year: "numeric",
});
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAccept = async () => {

    if (!accepted) {
      toast.error("Please accept the privacy policy to continue.");
      return;
    }

    setLoading(true);

    try {

      const loginData = JSON.parse(localStorage.getItem("loginData"));

      if (!loginData || !loginData.userid) {
        toast.error("Session expired. Please login again.");
        navigate("/login");
        return;
      }

      const secretKey = await fetchSecretKey();

      const encryptedPayload = encryptBody(
        { userid: loginData.userid },
        secretKey
      );

      const response = await axios.post(
        "/api/accept-privacy",
        encryptedPayload,
        {
          headers: { "Content-Type": "text/plain" },
        }
      );

      const decryptedResponse = decryptBody(response.data, secretKey);

      if (!decryptedResponse) {
        toast.error("Unable to process your request.");
        return;
      }

      if (!decryptedResponse.success && !decryptedResponse.token) {
        toast.error(
          decryptedResponse?.message ||
            "Unable to save privacy acceptance."
        );
        return;
      }

      localStorage.setItem("loginData", JSON.stringify(decryptedResponse));

      toast.success("Privacy Policy Accepted.");

      const role = decryptedResponse.role;

      if (role === "ROLE_SUPER") {
        navigate("/SuperDashboard", { replace: true });
      } else if (role === "ROLE_CARE_COORDINATOR") {
        navigate("/dashboard", { replace: true });
      } else if (role === "ROLE_DOCTOR") {
        navigate("/DoctorDashboard", { replace: true });
      } else if (role === "ROLE_USER") {
        navigate("/PatientDashboard", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }

      window.location.reload();

    } catch (err) {

      console.error(err);
      toast.error("An error occurred while accepting privacy policy.");

    } finally {

      setLoading(false);

    }
  };

  return (

    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f4f7fb",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px"
      }}
    >

      <div
        style={{
          width: "900px",
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
          overflow: "hidden"
        }}
      >

        {/* HEADER */}

        <div
          style={{
            backgroundColor: "#2e7fae",
            color: "white",
            padding: "20px",
            textAlign: "center",
            position: "relative"
          }}
        >

          {/* <img
            src="/careconnect.jpg"
            alt="Logo"
            style={{
              height: "45px",
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)"
            }}
          /> */}

          <h2 style={{ margin: 0, fontWeight: "600" }}>
            Privacy Policy
          </h2>

        </div>

        {/* POLICY CONTENT */}

        <div
          style={{
            maxHeight: "450px",
            overflowY: "auto",
            padding: "30px",
            lineHeight: "1.7",
            fontSize: "15px",
            color: "#333"
          }}
        >

        <h3 style={{ color: "#2e7fae" }}>CareConnect (CarePro AI Health Platform)</h3>
 <p><b>Effective Date:</b> {currentDate}</p>
{/* <p><b>Policy Version:</b> v1.0</p> */}

<h3 style={{ color: "#2e7fae" }}>1. Introduction</h3>
<p>
CareConnect (CarePro AI Health Platform) is committed to protecting the privacy, confidentiality, and security of personal and sensitive health information of its users, including patients, doctors, care coordinators, and healthcare partners.
</p>
<p>
This Privacy Policy explains how we collect, use, store, process, and protect user data when using our mobile application and related services.
</p>
<p>
By using the CareConnect mobile application, you agree to the terms outlined in this Privacy Policy.
</p>

<h3 style={{ color: "#2e7fae" }}>2. Information We Collect</h3>
<p>We collect the following categories of data:</p>

<p><b>2.1 Personal Information</b></p>
<ul>
<li>Full name</li>
<li>Phone number</li>
<li>Email address</li>
<li>Date of birth</li>
<li>Gender</li>
<li>Address</li>
<li>User identification details (Patient/Doctor ID)</li>
</ul>

<p><b>2.2 Sensitive Health Information</b></p>
<p>(Highly Sensitive Personal Data)</p>
<ul>
<li>Medical history</li>
<li>Diagnosis details</li>
<li>Treatment records</li>
<li>Prescriptions</li>
<li>Vital health parameters (BP, glucose, SpO2, heart rate, etc.)</li>
<li>Remote Patient Monitoring (RPM) device data</li>
</ul>

<p><b>2.3 Device and Technical Information</b></p>
<ul>
<li>Device identifiers</li>
<li>IP address</li>
<li>Operating system</li>
<li>App usage logs</li>
<li>Login activity</li>
<li>Crash reports</li>
</ul>

<p><b>2.4 Monitoring Device Data</b></p>
<ul>
<li>Data collected automatically from connected health devices (External devices not carepro’s)</li>
<li>Bluetooth-enabled medical device readings (External devices not carepro’s)</li>
</ul>

<h3 style={{ color: "#2e7fae" }}>3. Data Collection & Usage Summary</h3>
<p>We collect and process user data as follows:</p>

<table style={{ width: "100%", borderCollapse: "collapse" }}>
<thead>
<tr style={{ backgroundColor: "#2e7fae", color: "white" }}>
<th style={{ padding: "8px", border: "1px solid #ddd" }}>Data Type</th>
<th style={{ padding: "8px", border: "1px solid #ddd" }}>Purpose</th>
<th style={{ padding: "8px", border: "1px solid #ddd" }}>Shared With</th>
</tr>
</thead>
<tbody>
<tr>
<td style={{ padding: "8px", border: "1px solid #ddd" }}>Personal Information</td>
<td style={{ padding: "8px", border: "1px solid #ddd" }}>Account creation, communication</td>
<td style={{ padding: "8px", border: "1px solid #ddd" }}>Healthcare providers</td>
</tr>
<tr>
<td style={{ padding: "8px", border: "1px solid #ddd" }}>Health Data (Sensitive)</td>
<td style={{ padding: "8px", border: "1px solid #ddd" }}>Monitoring, alerts, treatment support</td>
<td style={{ padding: "8px", border: "1px solid #ddd" }}>Authorized doctors & care teams</td>
</tr>
<tr>
<td style={{ padding: "8px", border: "1px solid #ddd" }}>Device Data</td>
<td style={{ padding: "8px", border: "1px solid #ddd" }}>Security, performance, analytics</td>
<td style={{ padding: "8px", border: "1px solid #ddd" }}>Internal teams / system only</td>
</tr>
</tbody>
</table>

<p>
Please note: We DO NOT sell personal or health data and We DO NOT use health data for advertising or marketing
</p>

<h3 style={{ color: "#2e7fae" }}>4. How We Use Your Information</h3>
<p>We use collected data to:</p>
<ul>
<li>Provide remote patient monitoring services</li>
<li>Enable doctors to review patient health data</li>
<li>Generate alerts for abnormal health readings</li>
<li>Facilitate communication between patients and healthcare providers</li>
<li>Manage appointments and consultations</li>
<li>Improve app performance and healthcare services</li>
<li>Ensure system security and fraud prevention</li>
<li>Comply with legal and healthcare regulations</li>
</ul>

<h3 style={{ color: "#2e7fae" }}>5. User Consent & Permissions</h3>
<p>CareConnect collects personal and health data only after obtaining explicit user consent.</p>
<p>The app may request the following permissions:</p>
<ul>
<li>Bluetooth: To connect with health monitoring devices</li>
<li>Internet: To securely transmit health data</li>
<li>Notifications: To send alerts and reminders</li>
</ul>
<p>Users can manage or revoke permissions anytime through device settings.</p>

<h3 style={{ color: "#2e7fae" }}>6. Data Sharing and Disclosure</h3>
<p>We do NOT sell or rent user data.</p>
<p>We only share data with:</p>

<p><b>Authorized Healthcare Professionals</b></p>
<ul>
<li>Doctors, nurses, and care coordinators involved in treatment</li>
</ul>

<p><b>Healthcare Partners</b></p>
<ul>
<li>Hospitals or clinics associated with CareConnect</li>
</ul>

<p><b>Technical Service Providers</b></p>
<ul>
<li>Secure infrastructure and cloud service providers</li>
</ul>

<p><b>Legal Authorities</b></p>
<ul>
<li>When required by law or government regulations</li>
</ul>

<p>All third parties are bound by strict data protection and confidentiality obligations.</p>

<h3 style={{ color: "#2e7fae" }}>7. Data Security</h3>
<p>We implement industry-standard security measures, including:</p>
<ul>
<li>End-to-end encrypted data transmission</li>
<li>Secure cloud infrastructure</li>
<li>Role-based access control</li>
<li>Continuous monitoring and audits</li>
<li>Secure authentication systems</li>
</ul>

<p>Please note:  While we strive to protect data, no system is 100% secure.</p>

<h3 style={{ color: "#2e7fae" }}>8. Data Retention</h3>
<p>We retain data only as long as necessary to:</p>
<ul>
<li>Provide healthcare services</li>
<li>Maintain medical records</li>
<li>Comply with legal requirements</li>
</ul>
<p>Data is securely deleted or anonymized when no longer required.</p>

<h3 style={{ color: "#2e7fae" }}>9. User Rights</h3>
<p>Users have the right to:</p>
<ul>
<li>Access their personal data</li>
<li>Request correction of inaccurate data</li>
<li>Request deletion of data</li>
<li>Withdraw consent</li>
<li>Request information on data usage</li>
</ul>

<h3 style={{ color: "#2e7fae" }}>10. Account & Data Deletion</h3>
<p>Users can request deletion of their account and personal data by:</p>
<p>📧 Email: developer@careproaihealth.com</p>
<ul>
<li>Data will be deleted within 7–15 business days</li>
<li>Some data may be retained if legally required (e.g., medical records) for 12 months.</li>
</ul>

<h3 style={{ color: "#2e7fae" }}>11. Cookies and Analytics</h3>
<p>We may use cookies or similar technologies to:</p>
<ul>
<li>Improve user experience</li>
<li>Analyze usage patterns</li>
<li>Maintain secure sessions</li>
</ul>

<h3 style={{ color: "#2e7fae" }}>12. Third-Party Services and SDKs</h3>

<p>CareConnect may use trusted third-party services and SDKs such as:</p>

<ul>
<li>Cloud hosting providers</li>
<li>Communication APIs</li>
<li>Analytics tools (if applicable)</li>
<li>Medical device integrations</li>
</ul>

<p>
These third parties may process limited user data strictly for operational purposes and are contractually obligated to maintain data confidentiality and security.
CareConnect does not allow third parties to use user data for advertising or independent purposes.
</p>

<h3 style={{ color: "#2e7fae" }}>13. Children’s Privacy</h3>
<p>
CareConnect is not intended for users under 18 without guardian consent.
Parents/guardians may provide consent for minors where required.
</p>

<h3 style={{ color: "#2e7fae" }}>14. Changes to This Policy</h3>
<p>We may update this Privacy Policy periodically.</p>
<p>Users will be notified via:</p>
<ul>
<li>App notifications</li>
<li>Email (if applicable)</li>
</ul>

<h3 style={{ color: "#2e7fae" }}>15. Contact Information</h3>
<p>
CareConnect (CarePro AI Health Platform)<br/>
Operated by: CarePro AI Health Private Limited<br/>
📧 Email: developer@careproaihealth.com<br/>
🌐 Website: https://www.careproaihealth.com
</p>

<h3 style={{ color: "#2e7fae" }}>16. Compliance Statement</h3>
<p>
CareConnect complies with applicable data protection and healthcare regulations and ensures that sensitive health data is:
</p>
<ul>
<li>Used only for healthcare purposes</li>
<li>Shared only with authorized entities</li>
<li>Never used for advertising</li>
</ul>

<h3 style={{ color: "#2e7fae" }}>17. Google Play Data Safety Compliance</h3>
<p>
CareConnect ensures that all data collection, usage, and sharing practices described in this Privacy Policy are fully aligned with the disclosures provided in the Google Play Data Safety section of the app listing.
We are committed to maintaining transparency and accuracy in how user data is handled.
</p>

<h3 style={{ color: "#2e7fae" }}>18. No Advertising or Profiling</h3>
<p>CareConnect does not use personal or health data for:</p>
<ul>
<li>Advertising</li>
<li>Marketing</li>
<li>User profiling</li>
<li>Behavioral tracking</li>
</ul>
<p>All user data is used strictly for healthcare and operational purposes only.</p>

<h3 style={{ color: "#2e7fae" }}>19. Data Storage and International Transfers</h3>
<p>
User data may be stored and processed on secure servers located in India or other jurisdictions where our service providers operate.
We ensure all such data transfers comply with applicable data protection laws and maintain equivalent levels of data protection.
</p>

<h3 style={{ color: "#2e7fae" }}>20. Data Breach Notification</h3>
<p>In the event of a data breach affecting user information, CareConnect will:</p>
<ul>
<li>Take immediate steps to secure systems</li>
<li>Notify affected users where required by law</li>
<li>Cooperate with regulatory authorities as necessary</li>
</ul>

<h3 style={{ color: "#2e7fae" }}>21. Grievance Officer</h3>
<p>
In accordance with applicable laws, users may contact our Grievance Officer:<br/>
Name: Jayanth Kumar G<br/>
Email: developer@careproaihealth.com<br/>
We aim to resolve complaints within 15 working days.
</p>

<h3 style={{ color: "#2e7fae" }}>22. Conclusion and Disclaimer</h3>

<p>
CareConnect is a digital health platform designed to support remote patient monitoring in coordination with healthcare providers.
</p>

<p>
The app allows patients to record and share health data using compatible Bluetooth-enabled medical devices. Healthcare professionals can review this data and provide guidance as part of an ongoing care program.
</p>

<p><b>Key Features:</b></p>
<ul>
<li>Capture health readings using connected devices (e.g., blood pressure monitors, glucose meters)</li>
<li>Share health data securely with healthcare providers</li>
<li>Receive alerts and notifications based on configured thresholds</li>
<li>Video and audio communication with assigned healthcare professionals</li>
<li>Medication reminder notifications</li>
<li>Access to health history and reports</li>
<li>Emergency SOS alert to notify pre-configured contacts (Its only alert)</li>
</ul>


<p style={{ marginTop: "20px" }}>
<span style={{ fontWeight: "bold", color: "#000" }}>
Device Requirement:
</span>
CareConnect requires compatible external health monitoring devices to function. The app does not independently measure or generate health data.
</p>

<p style={{ marginTop: "15px" }}>
<span style={{ fontWeight: "bold", color: "#000" }}>
Intended Use:
</span>
This app is intended for use as part of a healthcare provider-guided monitoring program and is not designed for standalone medical use.
</p>


<p style={{ color: "red", fontWeight: "bold" }}>
DISCLAIMER:CareConnect is not a medical device and does not diagnose, treat, cure, or prevent any disease or medical condition. In case of a medical emergency, please contact your doctor or local emergency sos immediately.
</p>

<p style={{ marginTop: "20px", fontSize: "13px", color: "#777" }}>
© CareConnect (CarePro AI Health Platform). All rights reserved.
</p>

        </div>


        {/* ACCEPT SECTION */}

        <div
          style={{
            padding: "25px 30px",
            borderTop: "1px solid #eee"
          }}
        >

          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontWeight: "500"
            }}
          >

            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
              style={{ transform: "scale(1.2)" }}
            />

            I agree to the Privacy Policy

          </label>


          <button
            onClick={handleAccept}
            disabled={loading}
            style={{
              marginTop: "20px",
              padding: "12px 28px",
              backgroundColor: "#2e7fae",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "15px",
              cursor: loading ? "not-allowed" : "pointer"
            }}
          >

            {loading ? "Processing..." : "Continue"}

          </button>

        </div>

      </div>

    </div>
  );
}

export default Privacypolicy;

